module.exports = __webpack_public_path__ + "01_hige_gray.edcdd857.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/son/layer3/01_hige_gray.png
// module id = +69j
// module chunks = 0